import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import PostImages from "../../PostImages/index";
import LikeToggle from "../../common/LikeToggle/index";

import { Boldline } from "../../common/commonStyle";
import { Container, Category, Content, Aside, Embedded } from "./style";

function PostRender({ post }) {
  // const [like, setLike] = useState(post.likeCount);

  // const likeCountFunc = (v) => {
  //   setLike(v);
  // };s

  function embeddedUrl(Ogtag) {
    return (
      "<a href=" +
      Ogtag.og_url +
      " target=_blank rel=noopener noreferrer>" +
      "<article>" +
      "<main>" +
      "<h1>" +
      Ogtag.og_title +
      "</h1>" +
      "<div>" +
      "<p>" +
      Ogtag.og_desc +
      "</p>" +
      "</div>" +
      "</main>" +
      "<img src=" +
      Ogtag.og_images +
      " alt='link image' />" +
      "</article>" +
      "</a>"
    );
  }

  return (
    <>
      <Container key={post.boardId}>
        <Category>
          <div className="category">{post.category}</div>
          <div className="createAt">{post.createdDate}</div>
        </Category>

        <Link to={`/boards/${post.boardId}`}>
          <Content>
            {post.content}
            {post.Ogtag?.length > 0 && (
              <Embedded
                dangerouslySetInnerHTML={{
                  __html: embeddedUrl(post.Ogtag[0]),
                }}
              ></Embedded>
            )}
          </Content>
          {post.images[0] && <PostImages images={post.images} />}
        </Link>

        <Aside>
          <span className="nickName">{post.nickname}</span>
          <span className="aside__icons">
            <div className="likedDiv">
              <LikeToggle el={post} />
            </div>
            <div className="commentsDiv">
              <img className="comments" src="/img/comment.svg" alt="comments" />
            </div>
            <div>{post.commentCount}</div>
          </span>
        </Aside>
      </Container>
      <Boldline />
    </>
  );
}

export default PostRender;
